var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-learn-companion-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-learn-companion-shell",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-learn-companion-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "wkb-learn-companion-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
              _c("WorkspaceLearnCanvasPanel", {
                attrs: {
                  variant: "companion",
                  standalone: "",
                  "canvas-open-count": _vm.canvasOpenCount,
                  "learn-companion-max-opens": _vm.learnCompanionMaxOpens,
                },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }